module.exports = __webpack_public_path__ + "img/modalLogb.3f13763b.png";